import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ClipboardList, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { formatRands, shortId, ACTIVE_STATUSES } from "@/lib/order";
import { Card } from "@/components/ui/card";
import { StatusBadge } from "@/components/common/StatusViews";
import { CenterSpinner, EmptyState } from "@/components/common/States";
import { Button } from "@/components/ui/button";

export default function CustomerOrders() {
  const { data, isLoading } = useQuery({ queryKey: ["orders"], queryFn: () => api("/orders") });

  if (isLoading) return <CenterSpinner />;
  if (!data?.length)
    return (
      <EmptyState
        icon={ClipboardList}
        title="No orders yet"
        description="Your orders will appear here once you place one."
        action={<Link to="/"><Button className="rounded-full">Browse stores</Button></Link>}
      />
    );

  return (
    <div className="space-y-4">
      <h1 className="font-display text-2xl">Your orders</h1>
      <div className="space-y-3">
        {data.map((o) => (
          <Link key={o.order_id} to={`/order/${o.order_id}`} data-testid={`order-row-${o.order_id}`}>
            <Card className="flex items-center gap-4 rounded-2xl p-4 transition-colors hover:bg-muted/50">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="font-display text-base">{o.vendor_name}</span>
                  <StatusBadge status={o.status} />
                </div>
                <p className="mt-0.5 text-sm text-muted-foreground">
                  {shortId(o.order_id)} · {o.items?.length} item{o.items?.length > 1 ? "s" : ""} · {formatRands(o.total)}
                </p>
              </div>
              {ACTIVE_STATUSES.includes(o.status) && (
                <span className="hidden text-xs text-primary sm:inline">Track</span>
              )}
              <ChevronRight className="h-5 w-5 text-muted-foreground" />
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
